import React from 'react'
import PropTypes from 'prop-types'
import Paginated from 'meteor-paginated-graphql-react'
import Loading from 'orionsoft-parts/lib/components/Loading'
import styles from './styles.css'
import { withRouter } from 'react-router'
import MdGroup from 'react-icons/lib/md/group'
import autobind from 'autobind-decorator'
import isAdmin from '../../../Decorators/isAdmin'
import moment from 'moment'

@isAdmin
@withRouter
export default class Administration extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    admin: PropTypes.string
  }

  @autobind
  onSelect({ _id }) {
    this.props.router.push(`/admin/${_id}`)
  }

  getFields() {
    return [
      { title: '', name: '_id', render: () => <MdGroup size={20} /> },
      {
        title: 'Email',
        name: 'email',
        sort: 'ASC',
        render: ({email}) => <div className="d-flex" data-mobile-label="Email">{email}</div>
      },
      /*
      {
        title: 'Verified',
        name: 'emails.verified',
        render: item =>
          item.emails[0].verified ? (
            <MdCheck size={20} style={{ paddingLeft: 15, color: '#3cb371' }} />
          ) : (
            <MdClear size={20} style={{ paddingLeft: 15, color: 'red' }} />
          )
      }, */
      {
        title: 'Docs',
        name: 'totalDocuments',
        render: ({totalDocuments}) => <div className="d-flex" data-mobile-label="Docs">{totalDocuments}</div>
      },
      {
        title: 'Templates',
        name: 'templates',
        render: ({templates}) => <div className="d-flex" data-mobile-label="Templates">{templates}</div>
      },
      {
        title: 'Reg Domain',
        name: 'services.registerDomain',
        sort: 'ASC',
        render: ({services}) => <div className="d-flex" data-mobile-label="Reg Domain">{services.registerDomain}</div>
      },
      {
        title: 'Plan',
        name: 'plan',
        sort: 'ASC',
        render: ({plan}) => <div className="d-flex" data-mobile-label="Plan">{plan}</div>
      },
      {
        title: 'Creado',
        name: 'createdAt',
        render: item => (<span className="d-flex" data-mobile-label="Creado">{this.formatFecha(item.createdAt)}</span>),
        sort: 'ASC'
      }
    ]
  }

  formatFecha(fechaInt) {
    if (!fechaInt) { return ' - ' }
    return moment(fechaInt).format('DD/MM/YYYY')
  }

  render() {
    if (this.props.admin !== 'admin') {
      console.log('No admin')
      this.props.router.push('/')
      return null
    } else {
      return (
        <div className={styles.container}>
          <div className="section">
            <div className="table">
              <Paginated
                loadingComponent={Loading}
                queryName="users"
                fields={this.getFields()}
                ref="paginated"
                params="$filter: String"
                onPress={this.onSelect}
              />
            </div>
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/Users/index.js